<script>
import {relatorioArrematacaoLeilao} from "@/domain/leiloes/services"
import RelatorioTemplate from "./RelatorioTemplate"

export default {
  mixins: [RelatorioTemplate],
  nome: 'AutoArrematacao2',
  created() {
    this.isLoading = true
    relatorioArrematacaoLeilao(this.leilao.id, 'v2')
        .then((response) => {
          this.dados = response.data
          this.isLoading = false
        })
        .catch((response) => {
          // this.isLoading = false
          this.alertApiError(response)
          console.log(response)
        })
  }
}
</script>
